import { datadogRum } from '@datadog/browser-rum'

datadogRum.init({
  clientToken: 'pub974edea1e358c791122e7cb43a7d71ee',
  applicationId: 'd8e064d5-2c2f-45fa-92ac-bf0e6eb963ec',
  site: 'datadoghq.com',
  service: '360-training-frontend',
  env: process.env.SERVICE_ENV,
  version: process.env.GIT_COMMIT,
  sampleRate: 100,
  trackInteractions: true,
})

export default datadogRum
